import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function MasonryShowcaseFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setFacilitiesData(response?.data);
  };

  return (
    <>
      {facilitiesData?.length > 0 ? (
        <div
          id="portfolio-section"
          className="portfolio-section py-5 my-5 section-bg-img "
          style={{ backgroundImage: `url(/assets/images/mist/facilities-masonry-showcase-bg.webp)` }}
        >
          <div className="row px-4">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="title mb-0 text-uppercase typo-white">
                    Our Facilities
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row portfolio-wrap portfolio-classic-pro px-4"
            data-animation="fadeInDown"
          >
            {facilitiesData?.length === 0 ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <Spinner />
              </div>
            ) : (
              facilitiesData?.slice(0, 6)?.map((data, index) => (
                <div
                  key={index}
                  className="portfolio-item portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 col-xs-6 filter web animated fadeInLeft visible"
                >
                  <div className="portfolio-thumb relative">
                    <Link
                      to={`/facility/${data?.facility_slug
                        ?.replaceAll(" ", "-")
                        ?.replaceAll("/", "-")}`}
                    >
                      <img
                        src={data?.facility_image ||
                          "/assets/images/default.jpg"}
                        className="img-fluid"
                        alt={data?.facility_title}
                        style={{ height: "auto", width: "100%", objectFit: "cover" }}
                      />
                    </Link>
                    <div className="portfolio-wrap mansory-services-mobile-view">
                      <div className="portfolio-details-overlay typo-white">
                        <h3 className="mb-2">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                          >
                            {data?.facility_title}
                          </Link>
                        </h3>
                        <div className="portfolio-content w-75">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(data?.facility_short_description, 100) +
                                (data?.facility_short_description?.length > 100 ? "..." : ""),
                            }}
                          />
                        </div>
                      </div>
                      <div className="portfolio-icons">
                        <Link
                          to={`/facility/${data?.facility_slug
                            ?.replaceAll(" ", "-")
                            ?.replaceAll("/", "-")}`}
                          className="link-icon"
                        >
                          <i className="icon-link"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

        </div>
      ) : null}
    </>
  );
}

export default MasonryShowcaseFacilities;